import { AHIcon, Box, useTheme } from "arkh";
import Color from "color";
import React from "react";
import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
  },
});

export const PLUProductEditOverlay = React.memo(InnerPLUProductEditOverlay);

function InnerPLUProductEditOverlay() {
  const theme = useTheme();
  return (
    <Box style={styles.container}>
      <Box
        style={{
          backgroundColor: Color(theme.background).alpha(0.9).toString(),
        }}
        cornerRadius="medium"
        space="medium"
      >
        <AHIcon type="edit" color="primary" size="medium" />
      </Box>
    </Box>
  );
}
